import { useState, useCallback } from 'react';
import { schoolService } from '@modules/staff/schools/services/schoolService';
import useModal from '@shared/hooks/useModal';
import useFetchData from '@shared/hooks/useFetchData';
import { useEditHandler } from '@shared/hooks/useEditHandler';
import { useDeleteHandler } from '@shared/hooks/useDeleteHandler';

export const useSchools = () => {
    const [selectedData, setSelectedData] = useState(null);
    const [schoolData, setSchoolData] = useState(null);
    
    const { modalState, handleOpenModal, handleCloseModal } = useModal();
    const {
        data,
        pageNumber,
        pageSize,
        sortBy,
        sortDir,
        totalElements,
        totalPages,
        searchQuery,
        searchType,
        fetchData,
        setSearchQuery,
        handleSearchClick,
        setSearchType,
        handleSort,
        setPageSize,
        setpageNumber
    } = useFetchData();

    const handleEditSchool = useEditHandler({
        data,
        selectedData,
        setSelectedItem: setSchoolData,
        handleOpenModal,
        errorMessage: 'No school selected for editing'
    });

    const searchOptions = [
        { key: 'name', label: 'name' },
        { key: 'city', label: 'city' }
    ];

    const handleAddCloseModal = useCallback(() => {
        handleCloseModal();
        setSchoolData(null);
    }, [handleCloseModal]);

    const handleConfirmDelete = useDeleteHandler({
        service: schoolService,
        entityName: 'School',
        selectedData,
        fetchData,
        setSelectedData,
        handleCloseModal,
    });

    const selectedSchoolName = selectedData !== null
        ? data?.find(school => school.id === selectedData)?.name
        : '';

    
    return {
        data,
        selectedData,
        setSelectedData,
        schoolData,
        modalState,

        pageNumber,
        pageSize,
        sortBy,
        sortDir,
        totalElements,
        totalPages,

        searchQuery,
        searchType,
        searchOptions,

        handleOpenModal,
        handleCloseModal,
        handleAddCloseModal,
        handleEditSchool,
        handleConfirmDelete,
        handleSearchClick,
        setSearchQuery,
        setSearchType,
        handleSort,
        setPageSize,
        setpageNumber,
        selectedSchoolName,
        fetchData,
        schoolService
    };
}; 